var _path, _ellipse, _ellipse2, _ellipse3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7849 19.2263L21.5675 18.9498L20.7849 19.2263ZM19.4068 20.6044L19.1302 21.387L19.4068 20.6044ZM17.1364 19.8022L16.8599 20.5848L17.1364 19.8022ZM16.3576 19.8766L16.7601 20.6025L16.3576 19.8766ZM20.0091 16.1096L20.7472 16.4891L20.0091 16.1096ZM19.9494 16.862L19.1668 17.1385L19.9494 16.862ZM21.83 12C21.83 6.57104 17.429 2.17 12 2.17V3.83C16.5122 3.83 20.17 7.48783 20.17 12H21.83ZM20.7472 16.4891C21.4396 15.1425 21.83 13.6156 21.83 12H20.17C20.17 13.3455 19.8454 14.6128 19.2709 15.7301L20.7472 16.4891ZM21.5675 18.9498L20.732 16.5854L19.1668 17.1385L20.0023 19.5028L21.5675 18.9498ZM19.1302 21.387C20.6441 21.9219 22.1024 20.4637 21.5675 18.9498L20.0023 19.5028C20.0723 19.701 19.8814 19.8919 19.6833 19.8218L19.1302 21.387ZM16.8599 20.5848L19.1302 21.387L19.6833 19.8218L17.413 19.0196L16.8599 20.5848ZM12 21.83C13.7252 21.83 15.349 21.3848 16.7601 20.6025L15.9552 19.1507C14.7841 19.8 13.4365 20.17 12 20.17V21.83ZM2.17 12C2.17 17.429 6.57104 21.83 12 21.83V20.17C7.48783 20.17 3.83 16.5122 3.83 12H2.17ZM12 2.17C6.57104 2.17 2.17 6.57104 2.17 12H3.83C3.83 7.48783 7.48783 3.83 12 3.83V2.17ZM17.413 19.0196C16.9121 18.8426 16.3825 18.9138 15.9552 19.1507L16.7601 20.6025C16.8098 20.5749 16.8465 20.58 16.8599 20.5848L17.413 19.0196ZM19.2709 15.7301C19.056 16.1481 18.9967 16.657 19.1668 17.1385L20.732 16.5854C20.7274 16.5725 20.7223 16.5375 20.7472 16.4891L19.2709 15.7301Z",
    fill: "#2E2E30"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.0009,
    cy: 11.9998,
    rx: 1.22727,
    ry: 1.22727,
    transform: "rotate(-180 12.0009 11.9998)",
    fill: "#2E2E30"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.29629,
    cy: 11.9998,
    rx: 1.22727,
    ry: 1.22727,
    transform: "rotate(-180 7.29629 11.9998)",
    fill: "#2E2E30"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.7053,
    cy: 11.9998,
    rx: 1.22727,
    ry: 1.22727,
    transform: "rotate(-180 16.7053 11.9998)",
    fill: "#2E2E30"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/Message.0c81fd567634377b265383541f88c0ea.svg";
export { ForwardRef as ReactComponent };